import { FC } from "react";

export interface CommunityProps {
  width?: number;
  height?: number;
  className?: string | undefined;
}

export const CommunityDiscord: FC<CommunityProps> = (props) => {
  const { width = 20, height = 20, className } = props;

  return (
    <div className="orderly-fill-base-contrast-54 hover:orderly-fill-base-contrast">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={`${width}px`}
        height={`${height}px`}
        fill="current"
        fillOpacity={1}
        className={`${className}`}
      >
        <path d="M14.9559 5.5217C16.5596 7.89629 17.3515 10.5748 17.0555 13.6583C17.0542 13.6714 17.0475 13.6833 17.0368 13.6912C15.8224 14.5893 14.6458 15.1343 13.4857 15.4958C13.4767 15.4985 13.467 15.4984 13.4581 15.4953C13.4491 15.4923 13.4413 15.4865 13.4358 15.4788C13.1678 15.1032 12.9243 14.7073 12.7109 14.2915C12.6987 14.267 12.7099 14.2375 12.7351 14.2278C13.1218 14.0811 13.4896 13.9052 13.8434 13.6969C13.8712 13.6805 13.873 13.6403 13.8473 13.621C13.7722 13.5648 13.6978 13.5058 13.6266 13.4468C13.6133 13.4359 13.5954 13.4338 13.5803 13.4411C11.2837 14.5092 8.76789 14.5092 6.44412 13.4411C6.42903 13.4343 6.41111 13.4367 6.39815 13.4474C6.32715 13.5064 6.2526 13.5648 6.17823 13.621C6.1525 13.6403 6.15463 13.6805 6.18267 13.6969C6.53642 13.9012 6.90419 14.0811 7.29042 14.2285C7.31544 14.2382 7.32734 14.267 7.31491 14.2915C7.10618 14.7078 6.86265 15.1037 6.58967 15.4793C6.57777 15.4945 6.55825 15.5015 6.53979 15.4958C5.38518 15.1343 4.20857 14.5893 2.99415 13.6912C2.98403 13.6833 2.97676 13.6708 2.97569 13.6578C2.72826 10.9906 3.23253 8.28992 5.07333 5.52116C5.07776 5.51383 5.08451 5.50811 5.09232 5.50472C5.99808 5.08607 6.96844 4.77807 7.98265 4.60218C8.00111 4.59932 8.01957 4.6079 8.02915 4.62434C8.15446 4.84779 8.2977 5.13434 8.39461 5.36851C9.46367 5.20405 10.5494 5.20405 11.6408 5.36851C11.7377 5.13934 11.876 4.84779 12.0008 4.62434C12.0052 4.61619 12.0121 4.60965 12.0205 4.60567C12.0288 4.60169 12.0382 4.60047 12.0473 4.60218C13.062 4.77861 14.0324 5.08661 14.9374 5.50472C14.9454 5.50811 14.952 5.51383 14.9559 5.5217V5.5217ZM8.9381 10.593C8.94929 9.80452 8.37846 9.15206 7.66191 9.15206C6.95122 9.15206 6.3859 9.7988 6.3859 10.593C6.3859 11.387 6.96241 12.0338 7.66191 12.0338C8.37278 12.0338 8.9381 11.387 8.9381 10.593V10.593ZM13.6563 10.593C13.6675 9.80452 13.0966 9.15206 12.3803 9.15206C11.6694 9.15206 11.1041 9.7988 11.1041 10.593C11.1041 11.387 11.6806 12.0338 12.3803 12.0338C13.0966 12.0338 13.6563 11.387 13.6563 10.593V10.593Z" />
      </svg>
    </div>
  );
};

export const CommunityTG: FC<CommunityProps> = (props) => {
  const { width = 20, height = 20, className } = props;

  return (
    <div className="orderly-fill-base-contrast-54 hover:orderly-fill-base-contrast">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={`${width}px`}
        height={`${height}px`}
        // stroke="currentColor"
        fill="current"
        fillOpacity={1}
        className={`${className}`}
      >
        <path d="M4.10787 9.4635C4.10787 9.4635 9.64487 7.13143 11.5652 6.31025C12.3013 5.98181 14.7978 4.93069 14.7978 4.93069C14.7978 4.93069 15.95 4.47087 15.854 5.58763C15.822 6.0475 15.5659 7.65694 15.3099 9.39781C14.9258 11.8613 14.5097 14.5547 14.5097 14.5547C14.5097 14.5547 14.4457 15.3102 13.9016 15.4416C13.3575 15.5729 12.4613 14.9817 12.3013 14.8503C12.1733 14.7518 9.9009 13.2737 9.06876 12.5511C8.84471 12.354 8.58868 11.9599 9.10074 11.5C10.253 10.4161 11.6292 9.06937 12.4613 8.21537C12.8454 7.82119 13.2295 6.9015 11.6292 8.01825C9.35681 9.62774 7.11641 11.1387 7.11641 11.1387C7.11641 11.1387 6.60431 11.4671 5.64415 11.1715C4.68394 10.8759 3.56374 10.4817 3.56374 10.4817C3.56374 10.4817 2.79565 9.98906 4.10787 9.4635Z" />
      </svg>
    </div>
  );
};

export const CommunityX: FC<CommunityProps> = (props) => {
  const { width = 20, height = 20, className } = props;

  return (
    <div className="orderly-fill-base-contrast-54 hover:orderly-fill-base-contrast">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={`${width}px`}
        height={`${height}px`}
        // stroke="currentColor"
        fill="current"
        fillOpacity={1}
        className={`${className}`}
      >
        <path d="M4.41988 4.72946L9.05295 10.9243L4.39062 15.961H5.43993L9.52178 11.5513L12.8198 15.961H16.3906L11.4969 9.41769L15.8365 4.72946H14.7872L11.028 8.7907L7.9907 4.72946H4.41988ZM5.96296 5.50238H7.6034L14.8473 15.188H13.2069L5.96296 5.50238Z" />
      </svg>
    </div>
  );
};
